import { DatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { TextField } from "@mui/material";
import * as React from "react";
import { ChatMessagesAnalytics } from "./analytics/chatMessages";
import { DailyBattlesAnalytics } from "./analytics/dailyBattles";
import { DailyDeliveryAnalytics } from "./analytics/dailyDelivery";
import { MatchmakingAnalytics } from "./analytics/matchmaking";
import { PlayerSessionsAnalytics } from "./analytics/sessions/sessions";
import { UpgradesAnalytics } from "./analytics/upgrades";

interface PlayerAnalyticsState {
    loaded: boolean;
    haveError: boolean;
    dateRange: any;
}

interface PlayerAnalyticsProps {
    playerId: string;
    activeEnv: any;
    classes?: any;
}

export class PlayerAnalytics extends React.Component<PlayerAnalyticsProps, PlayerAnalyticsState> {

    constructor(props) {
        super(props);

        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 10);
        startDate.setHours(0);
        startDate.setMinutes(0);
        startDate.setSeconds(0);
        startDate.setMilliseconds(0);

        const endDate = new Date();
        endDate.setHours(23);
        endDate.setMinutes(59);
        endDate.setSeconds(59);
        endDate.setMilliseconds(59);

        this.state = {
            loaded: false,
            haveError: false,
            dateRange: {
                startDate,
                endDate,
            },
        };
    }

    changeLastLoginValue = (date: Date, type) => {
        const temp = { ...this.state.dateRange };

        if (type === "startDate") {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        } else if (type === "endDate") {
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            date.setMilliseconds(59);
        }

        temp[type] = date;

        this.setState({
            dateRange: temp,
        });
    };

    render() {
        return (
            <React.Fragment>
                <div style={{ float: "left", width: "100%" }}>
                    <div style={{ textAlign: "right" }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="Start date"
                                value={this.state.dateRange.startDate}
                                onChange={(e) => this.changeLastLoginValue(e, "startDate")}
                                renderInput={(params) => <TextField {...params} size="small" style={{ marginRight: 15 }}/>}
                            />

                            <DatePicker
                                label="End date"
                                value={this.state.dateRange.endDate}
                                onChange={e => this.changeLastLoginValue(e, "endDate")}
                                renderInput={(params) => <TextField {...params} size="small"/>}
                            />
                        </LocalizationProvider>
                    </div>
                </div>
                <div style={{ float: "left", width: "100%", marginTop: "1em" }}>
                    <PlayerSessionsAnalytics
                        activeEnv={this.props.activeEnv}
                        playerId={this.props.playerId}
                        dateRange={this.state.dateRange}
                    />

                    <ChatMessagesAnalytics
                        activeEnv={this.props.activeEnv}
                        playerId={this.props.playerId}
                        dateRange={this.state.dateRange}
                    />

                    <DailyDeliveryAnalytics
                        activeEnv={this.props.activeEnv}
                        playerId={this.props.playerId}
                        dateRange={this.state.dateRange}
                    />

                    <UpgradesAnalytics
                        activeEnv={this.props.activeEnv}
                        playerId={this.props.playerId}
                        dateRange={this.state.dateRange}
                    />

                    <MatchmakingAnalytics
                        activeEnv={this.props.activeEnv}
                        playerId={this.props.playerId}
                        dateRange={this.state.dateRange}
                    />

                    <DailyBattlesAnalytics
                        activeEnv={this.props.activeEnv}
                        playerId={this.props.playerId}
                        dateRange={this.state.dateRange}
                    />
               </div>
            </React.Fragment>
        );
    }
}
